import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { UserManagementAPI } from "../../axios";
import { useNavigate } from 'react-router-dom';
import Toolbar from '../Toolbar';
import Sidebar from '../Sidebar';

// Define validation schema using Yup
const RoleSchema = Yup.object().shape({
  roleName: Yup.string().required("Role Name is required"),
  countries: Yup.string().required("Countries are required"),
  description: Yup.string().required("Role Description is required"),
  permissions: Yup.array().min(1, "At least one permission is required").required("Permissions are required"),
});

const CreateRole = () => {
  const navigate = useNavigate();

  const initialValues = {
    roleName: "",
    countries: "",
    description: "",
    permissions: [],
  };

  const handleSubmit = (values) => {
    console.log('Form data', values);
    UserManagementAPI.add_role(JSON.stringify(values))
      .then((res) => {
        if (res.code === 200) {
          navigate('/manage-users');
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <div className="main-container">
        <Toolbar />
        <Sidebar />
        <div className="content-container">
          <div className="main-content">
            <div className="management-header">
              <h3>User Management</h3>
            </div>
            <div className="manage-headings">
            <span
              style={{
                textDecoration:'none',
                textDecorationColor: 'transparent',
                textDecorationThickness: 'auto',
                textUnderlineOffset: '0px',
                fontWeight: '400',
                cursor: 'pointer',
              }}
              onClick={() => { 
                navigate('/manage-users');
              }}
            >
              Manage Users
            </span>
            <span
              style={{
                textDecoration: 'underline',
                textDecorationColor: 'grey',
                textDecorationThickness: '2px',
                textUnderlineOffset: '4px',
                fontWeight: '500',
                cursor: 'pointer',
              }}
              onClick={() => { 
                navigate('/manage-roles');
              }}
            >
              Manage Roles
            </span>
          </div>
          <h2>Create New Role</h2>
            <Formik
              initialValues={initialValues}
              validationSchema={RoleSchema}
              onSubmit={handleSubmit}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <div className="form-container">
                    <div className="form-group">
                      <span className="role-label">Role Name</span>
                      <div className="role-input">
                        <Field type="text" name="roleName" />
                        <ErrorMessage name="roleName" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }}/>
                      </div>
                    </div>
                    <div className="form-group">
                      <span className="role-label">Countries</span>
                      <div className="role-input">
                        <Field type="text" name="countries" />
                        <ErrorMessage name="countries" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }}/>
                      </div>
                    </div>
                  </div>
                  <div className="form-description">
                    <span className="role-label">Role Description</span>
                    <div className="role-description">
                      <Field as="textarea" name="description" />
                      <ErrorMessage name="description" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }}/>
                    </div>
                  </div>
                  <div className="form-description">
                    <span className="role-label">Permissions</span>
                    <div className="role-permissions">
                      {["Can view users", "Can edit users", "Can delete users", "Can view report", "Can assign roles and countries"].map((permission, index) => (
                        <label key={index}>
                          <Field
                            type="checkbox"
                            name="permissions"
                            value={permission}
                            checked={values.permissions.includes(permission)}
                            onChange={() => {
                              const newPermissions = values.permissions.includes(permission)
                                ? values.permissions.filter((p) => p !== permission)
                                : [...values.permissions, permission];
                              setFieldValue("permissions", newPermissions);
                            }}
                          />
                          {permission}
                        </label>
                      ))}
                      <ErrorMessage name="permissions" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }}/>
                    </div>
                  </div>
                  <button type="submit" className="add-user">Create</button>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateRole;
